/** URL helpers shared by route heads; article metadata and bodies stay server-side. */
export type HelpAudience = "creators" | "members";
export const aiPolicyPath = "/help/articles/ai-policy";

/** Kept in the URL so searches, audience choices and the back button work together. */
export function helpSearch(value: Record<string, unknown>) {
  const q = typeof value.q === "string" ? value.q.trim().slice(0, 160) : "";
  return {
    q: q || undefined,
    audience: value.audience === "members" ? ("members" as const) : undefined,
  };
}

export function helpHref(path: string, audience: HelpAudience, q = "") {
  const search = new URLSearchParams();
  if (audience === "members") search.set("audience", audience);
  if (q) search.set("q", q);
  return `${path}${search.size ? `?${search}` : ""}`;
}
